import React from 'react';
import { useTranslation } from 'react-i18next';

import TablePagination from '@material-ui/core/TablePagination';

const Pagination = ({
  count,
  rowsPerPage,
  page,
  onChangePage,
  onChangeRowsPerPage,
}) => {
  const { t } = useTranslation();
  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
      component="div"
      labelRowsPerPage={t('table.labelRowsPerPage')}
      backIconButtonText={t('table.backIconButtonText')}
      nextIconButtonText={t('table.nextIconButtonText')}
      labelDisplayedRows={({ from, to, count }) => {
        return `${from}-${to} ${t('table.labelDisplayedRows')} ${count}`;
      }}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
    />
  );
};

export default Pagination;
